import { Component, OnInit } from '@angular/core';
import { SnackbarService } from '../../_service/message-service';
import { referralLinks } from './referralLinks';
@Component({
  selector: 'telio-referal-page',
  templateUrl: './referal-page.component.html',
  styleUrls: ['./referal-page.component.scss']
})
export class ReferalPageComponent implements OnInit {
  data = referralLinks;
  tenantObject;
  defaultLink = 'https://telioev.com/';

  constructor(private toastr: SnackbarService) { }

  ngOnInit(): void {
    let url = window.location.href
    let tenant = url.split("/").pop();
    this.tenantObject = this.data.find(x => x.tenant === tenant)
    this.openAppRedirection();
  }

  openAppRedirection() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case userAgent.search("iphone") > -1 || userAgent.search("ipad") > -1:
        window.location.href = (!!this.tenantObject.ios) ? this.tenantObject.ios : this.defaultLink
        break;
      case userAgent.search("android") > -1:
        window.location.href = (!!this.tenantObject.android) ? this.tenantObject.android : this.defaultLink
        break;

      default:
        window.location.href = this.defaultLink;
    }
  }

}

